import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: transparent;
  display: inline-flex;
  max-width: 100%;
  padding: 12px 16px;
`;
